<template>
  <v-snackbar
      v-model="show"
      :color="snackbarColor"
      top
      :timeout="timeout"
  >
    <v-icon
        :color="snackbarBtnColor"
        left
    >
      {{ icon }}
    </v-icon>
    <span class="font-weight-bold">
            {{ message }}
        </span>
    <template v-slot:action="{ attrs }">
      <v-btn
          :color="snackbarBtnColor"
          text
          v-bind="attrs"
          @click="show = false"
          class="font-weight-bold"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      icon: '',
      message: '',
      snackbarColor: '',
      snackbarBtnColor: '',
      timeout: null
    }
  },
  name: "SnackbarComponent",

  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'snackbar/showMessage') {
        this.icon = state.snackbar.icon
        this.message = state.snackbar.content
        this.snackbarColor = state.snackbar.snackbarColor
        this.snackbarBtnColor = state.snackbar.snackbarBtnColor
        this.show = true
      }
    })

    this.timeout = process.env.VUE_APP_SNACKBAR_TIMEOUT_MS;
  }
}
</script>
